import { createFileRoute } from "@tanstack/react-router";
import { ShoppingListFocusPage } from "@/pages/ShoppingList/ShoppingListFocusPage.tsx";

// Route détaillée d'une liste spécifique
export const Route = createFileRoute("/house/shopping-list/$listId")({
  component: () => <ShoppingDetail />,
});

const ShoppingDetail = () => {
  const { listId } = Route.useParams();
  return (
    <>
      <ShoppingListFocusPage listId={listId} />
    </>
  );
};
